<template>
	<div>
		<div class="title">保障计划及人员
			<span class="subtitle">同一保单仅支持购买一个方案</span>
		</div>
		<Form :model="form" :label-width="125" ref="form" class="mt15">
			<FormItem 
			label="保障期限：" class="w600" prop="insurancePeriod"
			:rules="{required:true,message:'请选择保障期限',trigger:'change'}">
				<Select 
					v-model="form.insurancePeriod" 
					placeholder="请选择保障期限" 
					style="width:100%"
					disabled
					@on-change="dateChange('insurancePeriod')">
					<Option value="1">1个月</Option>
				</Select>
			</FormItem>
			<FormItem label="保障起期：" class="w600" prop="effectiveDateStart" required>
				<DatePicker v-model="form.effectiveDateStart" type="date" placeholder="请选择保障起期" style="width: 100%" disabled @on-change="dateChange('effectiveDateStart')" :options="dateOptions">
				</DatePicker>
			</FormItem>
			<FormItem label="保障止期：" class="w600" required>
				{{ form.effectiveDateEnd }}
			</FormItem>
			<FormItem label="方案选择：" class="w600" required>
				<Select v-model="extraInfo.scheme" :disabled="disabledUrl" label-in-value placeholder="请选择保障方案" @on-change="caseChange" transfer>
					<Option :value="item.key" v-for="(item, inx) in caseList" :key="inx">{{ item.value }}</Option>
				</Select>
			</FormItem>
			<FormItem label="附加险：" class="w800" required>
				<RadioGroup v-model="extraInfo.isSubjoinProportionAdj" @on-change="isSubjoinProportionAdjChange">
					<Radio :label="0">十级伤残5%</Radio>
					<Radio :label="1">十级伤残10%</Radio>
				</RadioGroup>
				<Checkbox v-model="extraInfo.isCanteenAndDormitoryLiability" @on-change="aerialChange">员工食堂、宿舍责任</Checkbox>
			</FormItem>
			<FormItem label="人员明细：" required>
				<div class="download-btn">
					<div>
						<UploadFile style="display:inline-block" url="/pc/broker/import/importEmployee" :resAll="true" :show-upload-list="false" :data="uploadParams" btn-text="上传人员明细" @on-success="uploadSuccess" :disabled="!extraInfo.scheme" />
						<span class="downloadFile" v-if="extraInfo.scheme">
							<a @click="download">下载人员明细模板</a>
						</span>
					</div>
					<Button type="error" v-if="list.length > 0" @click="clearPersonList">清空人员信息</Button>
				</div>
			</FormItem>
			<FormItem label="人员汇总：" required>
				<Table :columns="columns" :data="list" highlight-row disabled-hover></Table>
				<Table :columns="totalColumns" :data="totalData" :show-header="false" v-if="list.length > 0" disabled-hover>
					<template slot-scope="{ row, index }" slot="count">
						{{ row.count }}人
					</template>
					<template slot-scope="{ row, index }" slot="totalAmount">
						{{ row.totalAmount }}元
					</template>
				</Table>
			</FormItem>
		</Form>
		<p class="errorMsg" v-if="errorMsg">{{ errorMsg }}</p>
		<Modal v-model="personListShow" :mask-closable="false" width="950" title="错误数据明细">
			<p style="color:red">存在错误数据，请检查并修正后重新上传</p>
			<el-table class="mt10" ref="table" :data="wrongData" style="width: 100%" :max-height="400">
				<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
				<el-table-column prop="no" label="错误数据位置" width="160"></el-table-column>
				<el-table-column prop="checkMsg" label="错误原因" show-overflow-tooltip width="200">
                    <template slot-scope="{ row }">
						{{ row.checkResult.result }}
					</template>
                </el-table-column>
				<el-table-column prop="insuredPersonName" label="姓名" width="100"></el-table-column>
                <el-table-column prop="idCard" label="身份证号" width="180"></el-table-column>
				<el-table-column prop="companyNameFrom" label="派遣单位" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="companyNameTo" label="实际用工单位" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="jobTypeName" label="岗位名称" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="province" label="用工单位所在省" width="180"></el-table-column>
				<el-table-column prop="city" label="用工单位所在市" width="180"></el-table-column>
				<el-table-column prop="district" label="用工单位所在区" width="180"></el-table-column>
            </el-table>
			<template slot="footer">
				<Button type="primary" @click="personListShow = false">确定</Button>
			</template>
		</Modal>
	</div>
</template>
<script>
import UploadFile from './common/UploadFile'
import SelectJob from './common/SelectJob'
export default {
	components: { UploadFile, SelectJob },
	props: {
		info: Object,
	},
	data() {
		return {
			id: this.$route.params.id,
			columns: [
				{ title: '序号', type: 'index', width: 100, align: 'center' },
				{ title: '风险类别', key: 'quoteRiskCategoryName'},
				{ title: '人数', key: 'quantity'},
				{ title: '保费单价（元/人）', key: 'premiumPer'},
				{ title: '保费小计（元）', key: 'premium'},
			],
			list: [],
			form: {
				insurancePeriod:'1'
			},
			extraInfo:{
				isSubjoinProportionAdj:0,
				isCanteenAndDormitoryLiability:false,
				schemeName:''
			},
			dateOptions: {},
			caseList: [],
			totalColumns: [
				{ title: '', key: 'title', minWidth: 200, align: 'right' },
				{ title: '', slot: 'count', width: 120 },
				{ title: '', slot: 'totalAmount', width: 190 },
			],
			totalData: [{
				title: '合计',
				count: '',
				totalAmount: '',
			}],
			errorMsg: '',
			personList: [],
			personListShow: false,
			isReset: this.$route.query.reset || '', // 是否重新投保
			orderNo: this.$route.query.orderNo || '',
			wrongData: [] // 错误数据
		}
	},
	computed: {
		/*校验人员明细*/
		disabledUrl() {
			return this.personList.length > 0 ? true : false;
		},
		uploadParams() {
			return {
				applicationReqDTO: JSON.stringify({
					subjectMatter: [],
					insurancePeriod: this.form.insurancePeriod,
					extraInfo: {...this.extraInfo,isSubjoinProportionAdj:Boolean(this.extraInfo.isSubjoinProportionAdj)},
					productCode: this.$route.query.productCode || this.info.productCode,
					effectiveDateStart: this.formatDate(this.form.effectiveDateStart),
					effectiveDateEnd: this.formatDate(this.form.effectiveDateEnd),
					bizId: 'INDUSTRY_ENTERPRISE',
					companyId: this.getCompanyId(this.info.productCode)
				}),
				isDeterminedGroup:false,
				returnErrorOnly: true
			}
		}
	},
	watch: {
		info(v) {
			this.setData();
			if (v.productCode) {
				this.form.insurancePeriod = v.insurancePeriod=='12'?'1':String(v.insurancePeriod);
				this.setStartTimeOption();
				this.getCaseList();
			}
		}
	},
	async created() {
		this.setData();
		this.form.insurancePeriod = this.form.insurancePeriod=='12'?'1':String(v.insurancePeriod);
		if (!this.isReset) {
			this.setStartTimeOption();
		}
		if (this.info.productCode) {
			await this.getCaseList();  // 先等待获取方案列表
		}
	},
	methods: {
		riskCategoryShow(name){
			let str = ''
			switch(name){
				case 'RISK_1':
					str = "一类"
				break;
				case 'RISK_2':
					str = "二类"
				break;
				case 'RISK_3':
					str = "三类"
				break;
				case 'RISK_4':
					str = "四类"
				break;
				case 'RISK_5':
					str = "五类"
				break;
				case 'RISK_6':
					str = "六类"
				break;
				default:
					str = ""
				break;
			}
			return str
		},
		// 清空人员信息
		clearPersonList() {
			this.$Modal.confirm({
				title: '确定清空人员信息？',
				okText:'取消',
				cancelText:'确认',
				onOk: () => {
					
				},
				onCancel: () => {
					this.personList = [];
					this.list = [];
					this.getPremium();
				}
			});
		},
		convertTree(tree) {
			let list = tree.map(item => {
				return {
					...item,
					loading: false
				}
			})
			let result = JSON.parse(JSON.stringify(list).replace(/"value"/g, '"label"').replace(/"key"/g, '"value"'))
			return result
		},
		async setStartTimeOption() {
			let startDate = await this.getEffectiveDateStartRange(this.formatDate(new Date()), 1, 'start');
			this.dateOptions = {
				disabledDate(date) {
					return date && (date.valueOf() < Date.parse(startDate + ' 00:00:00'))
				}
			}
			this.form.effectiveDateStart = startDate;
			this.dateChange();
		},
		setData() {
			this.form = this.jsonCopy(this.info);
			this.form.insurancePeriod = String(this.info.insurancePeriod)
			if(this.info.extraInfo){
				this.extraInfo = this.info.extraInfo;
				this.extraInfo.isSubjoinProportionAdj = Number(this.extraInfo.isSubjoinProportionAdj)
			}
			if (this.info.subjectMatter) {
				this.personList = this.info.subjectMatter;
			};
			if (this.info.subjectMatterGroupStats) {
				this.list = this.info.subjectMatterGroupStats;
			}
			this.getPremium();
		},
		// 获取方案列表
		async getCaseList() {
			await this.$axios.post('/broker/dict/items/plain.json', {
				bizId: 'INDUSTRY_ENTERPRISE',
				dictCode: 'product_plan',
				productCode: this.info.productCode,
				companyId: this.getCompanyId(this.info.productCode)
			}).then(res => {
				this.caseList = res;
			});
		},
		// 草稿箱
		drafts(){
			return new Promise ((resolve,rejct)=>{
				resolve({
					employerTotalAmountVO: {
						subjectMatterQuantity: this.totalData[0].count,
						effectiveDateStart: this.formatDate(this.form.effectiveDateStart),
						effectiveDateEnd: this.form.effectiveDateEnd,
						insurancePeriod: this.form.insurancePeriod,
						premium: this.totalData[0].totalAmount,
						extraInfo: {...this.extraInfo,isSubjoinProportionAdj:Boolean(this.extraInfo.isSubjoinProportionAdj)}
					},
					importEmployeeVOS: this.personList,
					subjectMatter: this.list
				})
			})
		},
		// 校验
		async val() {
			let flag = await this.$refs.form.validate();
			return new Promise((resolve, reject) => {
				if (flag) {
					resolve({
						employerTotalAmountVO: {
							subjectMatterQuantity: this.totalData[0].count,
							effectiveDateStart: this.formatDate(this.form.effectiveDateStart),
							effectiveDateEnd: this.form.effectiveDateEnd,
							insurancePeriod: this.form.insurancePeriod,
							premium: this.totalData[0].totalAmount,
							extraInfo: {...this.extraInfo,isSubjoinProportionAdj:Boolean(this.extraInfo.isSubjoinProportionAdj)}
						},
						importEmployeeVOS: this.personList,
						subjectMatter: this.list
					})
				} else {
					this.toast('保障计划或上传人员错误', 'error');
					resolve(false)
				}
			})
		},
		/*日期变化后获取起保终保日期*/
		dateChange(type) {
			if (this.form.effectiveDateStart) {
				this.getEffectiveDateEnd(this.formatDate(this.form.effectiveDateStart), this.form.insurancePeriod).then(res => {
					this.$set(this.form, 'effectiveDateEnd', res)
					this.getPremium();
				})
			}
		},
		// 获取保障范围
		getEffectiveDateStartRange(effectiveDateStart, insurancePeriod, type = 'end') {
			return this.$axios.post('/broker/insurance/application/getEffectiveDateStartRange.json', {
				effectiveDateStart: effectiveDateStart,
				insurancePeriod: insurancePeriod,
				productCode: this.info.productCode
			}).then(res => {
				if (type == 'end') {
				} else {
					return res.effectiveStartDateStart
				}
			})
		},
		// 获取保障止期，父页面fillin也会用到
		getEffectiveDateEnd(effectiveDateStart, insurancePeriod, type = 'end') {
			return this.$axios.post('/broker/insurance/application/getEffectiveDateEnd.json', {
				effectiveDateStart: effectiveDateStart,
				insurancePeriod: insurancePeriod,
				productCode: this.info.productCode
			}).then(res => {
				if (type == 'end') {
					return res.effectiveDateEnd
				} else {
					return res.effectiveDateStart
				}
			})
		},
		/*上传成功后获取数据*/
		uploadSuccess(res) {
			console.log(res,'上传成功后获取数据')
			if(res.code===10000000){
				this.$nextTick(()=>{
					if(res.data&&res.data.length>0&&res.data[0].checkResult.empty){
						this.personList = res.data || [];
						this.list = res.stats || [];
						this.getPremium();
					} else {
						this.personListShow = true;
						this.wrongData = res.data || [];
					}
					console.log(res,'上传成功后获取数据')
				})
			} else {
				this.alert(res.msg)
			}
		},
		charAtCode(code) {
			if (code) return (this.$route.query.productCode || this.info.productCode) + code.charAt(code.length - 1)
			else return ''
		},
		/*获取保费*/
		async getPremium() {
			if (this.list.length == 0) {
				this.totalData = [{
					title: '合计',
					count: '',
					totalAmount: '',
				}]
				this.$emit('set-amount', 0)
				this.errorMsg = ''
				return
			}
			let obj = {
				subjectMatter: this.list,
				insurancePeriod: this.form.insurancePeriod,
				extraInfo: {...this.extraInfo,isSubjoinProportionAdj:Boolean(this.extraInfo.isSubjoinProportionAdj)},
				productCode: this.$route.query.productCode || this.info.productCode,
				effectiveDateStart: this.formatDate(this.form.effectiveDateStart),
				effectiveDateEnd: this.formatDate(this.form.effectiveDateEnd),
				bizId: 'INDUSTRY_ENTERPRISE',
			}
			if (!obj.effectiveDateStart) return
			let res = await this.$axios.post('/broker/quote.json', obj)
			this.$emit('set-amount', res.premium)
			res.subjectMatter.forEach((item) => {
				this.list.forEach((item2,index2)=>{
					if(item2.quoteRiskCategory==item.quoteRiskCategory){
						this.$set(item2,'premium',item.premium);
						this.$set(item2,'premiumPer',item.premiumPer);
						this.list.splice(index2, 1, item2);
					}
				})
			})
			this.totalData = [{
				title: '合计',
				count: res.subjectMatterQuantity,
				totalAmount: res.premium,
			}]
		},
		// 选择方案
		caseChange(item) {
			if(!item){
				return
			}
			this.$set(this.extraInfo,'schemeName',item.label);
			if(item.value&&this.list.length>0){
				this.getPremium();
			}
		},
		// 选择高空，非高空
		aerialChange () {
			if(this.list.length>0){
				this.getPremium();
			}
		},
		isSubjoinProportionAdjChange(){
			if(this.list.length>0){
				this.getPremium();
			}
		},
		// 下载模板
		download() {
			this.$axios.post('/broker/export/exportTemplate/SUNLIGHT_EMPLOYER_LIABILITY.json', this.list).then(res => {
				if (res) {
					this.getBlob(res).then((blob) => {
						this.saveAs(blob, '人员信息表')
					})
				}
			})
		},
		getBlob(url) {
			return new Promise((resolve) => {
				const xhr = new XMLHttpRequest()
				xhr.open('GET', url, true)
				xhr.responseType = 'blob'
				xhr.onload = () => {
					if (xhr.status === 200) {
						resolve(xhr.response)
					}
				}
				xhr.send()
			})
		},
		// 自定义下载文件名称
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			} else {
				const link = document.createElement('a')
				const body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob) // 创建对象url
				link.download = filename

				// fix Firefox
				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)

				window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
			}
		}
	}
}
</script>
<style scoped lang="less">
.download-info {
	font-size: 16px;

	span {
		color: #FF9900;
		margin-left: 20px;
	}
}

.recognize {
	&-title {
		font-weight: bold;
	}

	&-total {
		font-size: 16px;
	}
}

.caseContainer {
	padding: 10px 0;
}

.subtitle {
	color: #FF9900;
	font-size: 16px;
	margin-left: 20px;
}

.downloadFile {
	margin-left: 20px;
	margin-right: 20px;
}

.errorMsg {
	font-size: 16px;
	color: red;
}
.download-btn{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/RecognizeCcic_M5.vue